import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { AppData, Getters, Mutations, Actions } from '@/models/App.model';

// Inital state
const state: AppData = {
  urls: {
    login: process.env.VUE_APP_URL_LOGIN,
  },
  snackbar: {
    show: false,
    text: '',
    color: 'error',
    mode: '',
    timeout: Number(process.env.VUE_APP_SNACKBAR_TIMEOUT),
    x: '',
    y: 'top',
    icon: '',
    closeIcon: 'mdi-close-circle-outline',
  },
  icons: {
    // --- generic ---
      // -- informational
      error: 'mdi-alert',
      warning: 'mdi-bell',
      success: 'mdi-check-circle',
      settings: 'mdi-cog',
      username: 'mdi-account',
      password: 'mdi-lock',
      profile: 'mdi-account',
      email: 'mdi-email-send-outline',
      pdf: 'mdi-file-pdf',
      favourite: 'mdi-star',
      // --- actions ---
      refresh: 'mdi-refresh-circle',
      login: 'mdi-fingerprint',
      register: 'mdi-account-plus',
      filter: 'mdi-filter-variant',
      search: 'mdi-magnify',
      close: 'mdi-close-circle-outline',
      view: 'mdi-eye',
      edit: 'mdi-pencil',
      delete: 'mdi-delete',
      copy: 'mdi-content-copy',
      activate: 'mdi-play',
      suspend: 'mdi-pause',
      expand: 'mdi-menu-down',
      contract: 'mdi-menu-up',
      print: 'mdi-printer',

  // --- app specific ---
    // --- informational ---
      waybillNumber: 'mdi-tag-text-outline',
      returns: 'mdi-keyboard-return',
      thankyou: 'mdi-thumb-up',
  },
  messages: {
    couldNotConnect: 'Error: Please contact the Store for assistance.',
    sessionTimeout: 'Your session has timed out, please login to continue.',
  },
  drawer: null,
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, AppData> = {
  urls: (state) => state.urls,
  snackbar: (state) => state.snackbar,
  icons: (state) => state.icons,
  messages: (state) => state.messages,
  drawer: (state) => state.drawer,

  provinces: (state) => {
    return [
      'Eastern Cape',
      'Free State',
      'Gauteng',
      'KwaZulu-Natal',
      'Limpopo',
      'Mpumalanga',
      'North West',
      'Northern Cape',
      'Western Cape',
    ];
  },
};

// TODO: Change mutation names to uppercase ( Standards )
// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, AppData> = {
  reset(state) {
    // only reset the values that can be updated
    state.snackbar = {
      show: false,
      text: '',
      color: 'error',
      mode: '',
      timeout: 6000,
      x: '',
      y: 'top',
      icon: '',
      closeIcon: 'mdi-close-circle-outline',
    };

    state.drawer = null;
  },

  snackbar(state, { show, text, color, icon }) {
    state.snackbar.show = show;
    state.snackbar.text = text;
    state.snackbar.color = color;
    state.snackbar.icon = icon;
  },

  SET_DRAWER(state, payload) {
    state.drawer = payload;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, AppData, Mutations, Getters> = {
  reset({ commit }, payload) {
    commit('reset', payload);
  },

  snackbar({ commit }, payload) {
    commit('snackbar', payload);
  },

  SET_DRAWER({ commit }, payload) {
    commit('SET_DRAWER', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<AppData, Getters, Mutations, Actions>(
  'AppModule',
);

export const AppModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
